// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__L8M_H","error":"Button_error__1ZqKt","success":"Button_success__ja_9l","primary":"Button_primary__29otg"};